import React from "react";

/** Top-level error boundary: prevents one page crash from blanking the whole app. */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("Uncaught error in tree:", error, info);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background" dir="rtl">
        <div className="max-w-md w-full rounded-xl border border-border bg-white p-8 text-center shadow-sm">
          <div className="mx-auto h-12 w-12 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center mb-4 text-2xl">!</div>
          <h2 className="font-display text-xl font-semibold text-foreground">حدث خطأ غير متوقع</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            نعتذر عن الإزعاج. يمكنك المحاولة مرة أخرى.
          </p>
          <pre dir="ltr" className="mt-4 p-3 bg-slate-50 rounded-md text-[11px] text-slate-600 overflow-auto max-h-32 text-start">
            {String(this.state.error?.message || this.state.error || "Unknown error")}
          </pre>
          <div className="mt-4 flex gap-2 justify-center">
            <button
              onClick={this.reset}
              className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:opacity-90"
              data-testid="error-reset-btn"
            >
              محاولة مجددًا
            </button>
            <button
              onClick={() => (window.location.href = "/dashboard")}
              className="h-9 px-4 rounded-md border border-border text-sm font-medium hover:bg-slate-50"
              data-testid="error-home-btn"
            >
              العودة للوحة القيادة
            </button>
          </div>
        </div>
      </div>
    );
  }
}
